import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchFilter' })
export class SearchFilterPipe implements PipeTransform {

  public transform(items: any, keys: string, searchText: any) {

    // RegExp:
    // g modifier: global. All matches (don't return on first match)
    // i modifier: insensitive. Case insensitive match (ignores case of [a-zA-Z])

    // if searchText is undefine then it return the current page data of pagination
    // but if user search then we should not be showing search result from current page 
    // of pagination but instead of whole array of allItems,
    // so getting this.pagerService.allItems from PagerService

    if (!searchText) {
      return items;
    }
    return (items || [])
      .filter((item) => keys.split(',')
        .some(key => {
          // if key is present in nested object of item use nestedObj.keyName when using this filter
          // ex: see show-users html
          if (key.includes('.')) {
            
            const nestedKey = key.split('.');
            const nestedObject = item[nestedKey[0]];

            // This was added to compensate for items that were more than two levels deep inside a JSON. 
            // If the value is true then we break out of the forEach since once it's true it's true for everything. 
            /*
            let newArray;
            let testBool;
            let breakLoop;
             
            nestedObject.forEach(element => {
                 testBool = (element.hasOwnProperty(nestedKey[1]) && new RegExp(searchText.replace('\\', ''), 'gi')
                 .test(element[nestedKey[1]]));

                 if (testBool === true) {
                  breakLoop = true;
                 } else {
                   breakLoop = false;
                 }
              });


              if (breakLoop == true) {
                return true;
              } */
              if(nestedKey.length > 2){
                const nestedSubObject = nestedObject[nestedKey[1]];
                return nestedSubObject.hasOwnProperty(nestedKey[2]) && new RegExp(searchText.replace(/\\/g, ''), 'gi')
              .test(nestedSubObject[nestedKey[2]]);
              }
              // This is the end of the additional code. 
            
            return nestedObject.hasOwnProperty(nestedKey[1]) && new RegExp(searchText.replace(/\\/g, ''), 'gi')
              .test(nestedObject[nestedKey[1]]);
          }
          return item.hasOwnProperty(key) && new RegExp(searchText.replace(/\\/g, ''), 'gi')
            .test(item[key]);
        }));
  }
}
